import type { BedQuantity, QuantityChange } from "./transferWorkflowApi";

export function allocateBeds(beds: BedQuantity[], quantity: number): BedQuantity[] {
  let remaining = quantity;
  const result: BedQuantity[] = [];
  for (const bed of beds) {
    const amount = Math.min(bed.quantity, remaining);
    if (amount > 0) result.push({ bedId: bed.bedId, quantity: amount });
    remaining -= amount;
  }
  // An increase remains explicitly assigned to the final selected bed; the server validates availability.
  if (remaining > 0 && beds.length) result.push({ bedId: beds[beds.length - 1].bedId, quantity: remaining });
  return result.reduce<BedQuantity[]>((all, bed) => {
    const existing = all.find(b => b.bedId === bed.bedId);
    if (existing) existing.quantity += bed.quantity; else all.push({ ...bed });
    return all;
  }, []);
}
export function describeAmendment(before: string, after: string, labels: Record<string, string>): string {
  try {
    const old = JSON.parse(before) as { LineId: string; Quantity: number }[];
    const next = JSON.parse(after) as { LineId: string; Quantity: number }[];
    return next.map(line => `${labels[line.LineId] ?? "Stock"}: ${old.find(l => l.LineId === line.LineId)?.Quantity ?? 0} → ${line.Quantity}`).join("; ");
  } catch { return "Quantity and bed allocation amendment"; }
}
export function positiveChanges(values: Record<string, number>): QuantityChange[] {
  return Object.entries(values).filter(([, quantity]) => Number.isSafeInteger(quantity) && quantity > 0)
    .map(([lineId, quantity]) => ({ lineId, quantity }));
}
